<template>
  <div
    id="article-card"
    class="d-flex align-items-center cursor-pointer px-5 py-4"
    :class="{ 'article-selected': isArticleSelected, 'border-bottom': index !== GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS.length - 1 }"
    @click="selectArticle()"
    data-test="article-card"
    :data-uuid="`${this.article.encodedExternalId}`"
  >
    <div
      v-if="displayImage"
      class="flex-shrink-0 mr-4"
    >
      <div
        id="article-img-container"
      >
        <img
          id="article-img"
          :src="articleImage"
          alt="article-image"
          data-test="article-image"
        >
      </div>
    </div>
    <div
      class="d-flex flex-column justify-content-between h-100 w-100"
    >
      <p
        id="article-title"
        class="text-wrap"
        data-test="article-title"
      >
        {{ articleTitle }}
      </p>
      <div>
        <p
          class="small text-muted"
        >
          State: {{ articleState }}
        </p>
        <div
          class="d-flex justify-content-between align-items-center"
        >
          <p
            class="small text-muted"
          >
            Edited: {{ articleEditedDate }}
          </p>
          <p
            :class="['text-muted flex-shrink-0', {'hidden': !hasComments}]"
            :key="selectedCreativeId"
            data-test="comment-count"
          >
            <i class="fal fa-comment-alt" />
            {{ articleCommentsCount }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions, mapState, mapGetters,
} from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

import dateHelper from '@/core/mixins/dateHelper';

export default {
  name: 'ArticleCard',
  mixins: [
    dateHelper,
  ],
  props: {
    article: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: () => 0,
    },
    displayImage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('content', [
      'selectedCreativeId',
      'selectedArticleUuid',
      'commentsCounts',
    ]),
    ...mapGetters('content', [
      contentTypes.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS,
    ]),
    articleImage() {
      return this.article.imageUrl || '/images/image-not-found.png';
    },
    articleTitle() {
      return this.article.title || '';
    },
    articleState() {
      return this.article.state || '';
    },
    articleEditedDate() {
      return this.formatDateForPlatform(this.article.updatedDate) || '';
    },
    isArticleSelected() {
      if (!this.selectedArticleUuid && this.index === 0) this.selectArticle();
      return this.selectedArticleUuid === this.article.encodedExternalId;
    },
    hasComments() {
      return this.commentsCounts.hasOwnProperty(this.article.encodedExternalId);
    },
    articleCommentsCount() {
      return this.commentsCounts[this.article.encodedExternalId]?.count;
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.SET_SELECTED_ARTICLE_UUID,
    ]),
    selectArticle() {
      this.SET_SELECTED_ARTICLE_UUID(this.article.encodedExternalId);
    },
  },
};
</script>
<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
#article-card {
  height: 136px;
}
.article-selected {
  background-color: $link-light;
}
#article-img-container {
  width: 104px;
  height: 104px;
}
#article-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
#article-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  line-height: 1.25rem;
}
.small {
  font-size: 0.75rem;
}
.hidden {
  visibility: hidden;
}
</style>
